import { render, staticRenderFns } from "./RegisterBookEdit.vue?vue&type=template&id=a28ab09c&"
import script from "./RegisterBookEdit.vue?vue&type=script&lang=js&"
export * from "./RegisterBookEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports